// @owners { team: patients-team }
import { Button } from '@alto/design-system';
import React from 'react';
import { getAutoRefillNamesForShipment } from '~shared/features/auto-refill/selectors/getAutoRefillNamesForShipment';
import { getShipmentWithItemsByID } from '~shared/features/shipments/selectors/getShipmentsWithItems';
import getIsMedSyncUser from '~shared/features/users/selectors/getIsMedSyncUser';
import { useAnalytics } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { useSelectorShared } from '~shared/store';

export type SnoozeButtonProps = {
  readonly handleOpenSnooze?: () => void; //because no web functionality
  readonly shipmentID: number;
  readonly userID?: number;
};

export const SnoozeButton = ({ handleOpenSnooze, shipmentID, userID }: SnoozeButtonProps) => {
  const { trackEvent } = useAnalytics();
  const shipment = useSelectorShared((state) => getShipmentWithItemsByID(state, { id: shipmentID }));
  const autoRefillNamesForShipment = useSelectorShared((state) => getAutoRefillNamesForShipment(state, { shipmentID }));
  const isMedSync = useSelectorShared((state) => getIsMedSyncUser(state, { userID }));
  const shipmentContainsAutoRefillPrescriptions = autoRefillNamesForShipment.length > 0;
  const isPickup = shipment?.shipment_method === 'pickup';

  const isSnoozeEnabled = shipmentContainsAutoRefillPrescriptions && !isMedSync && !isPickup;

  if (!isSnoozeEnabled || !handleOpenSnooze) return null;

  const onPress = () => {
    handleOpenSnooze();
    trackEvent({ event: EVENTS.DELIVERY_DETAILS_SNOOZE_BUTTON_CLICKED, additionalFields: { shipmentId: shipmentID } });
  };

  return (
    <Button
      accessibilityLabel="Snooze Delivery Button"
      onPress={onPress}
      small
      type="secondary"
      testID="snooze-delivery-button"
      width="inline"
    >
      Snooze
    </Button>
  );
};
